// Defer Payment Buttons Loading
// This script intercepts and delays Shopify's payment button initialization

(function() {
  // Store the original PaymentButton object if it exists
  const originalPaymentButton = window.Shopify && window.Shopify.PaymentButton;
  let paymentButtonsDeferred = [];
  let shouldLoadPaymentButtons = false;
  
  // Override Shopify.PaymentButton to capture initialization calls
  if (window.Shopify) {
    window.Shopify.PaymentButton = {
      init: function() {
        if (shouldLoadPaymentButtons && originalPaymentButton) {
          // Load immediately if we've decided it's time
          return originalPaymentButton.init.apply(originalPaymentButton, arguments);
        } else {
          // Store the call for later
          paymentButtonsDeferred.push(arguments);
        }
      }
    };
  }
  
  // Function to actually load payment buttons
  function loadPaymentButtons() {
    if (shouldLoadPaymentButtons) return;
    shouldLoadPaymentButtons = true;
    
    console.log('Loading payment buttons...');
    
    // Restore original PaymentButton
    if (originalPaymentButton && window.Shopify) {
      window.Shopify.PaymentButton = originalPaymentButton;
      
      // Process any deferred calls
      paymentButtonsDeferred.forEach(args => {
        originalPaymentButton.init.apply(originalPaymentButton, args);
      });
      
      // Clear the deferred array
      paymentButtonsDeferred = [];
      
      // Trigger any new payment button initializations
      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }
    }
  }
  
  // Function to check if payment buttons are in viewport
  function isPaymentButtonVisible() {
    const buttons = document.querySelectorAll('.shopify-payment-button, [data-shopify-payment-button], .product__submit__item--payment');
    
    for (let button of buttons) {
      const rect = button.getBoundingClientRect();
      if (rect.top <= window.innerHeight && rect.bottom >= 0) {
        return true;
      }
    }
    
    return false;
  }
  
  // Set up deferred loading
  document.addEventListener('DOMContentLoaded', function() {
    let checkVisibilityTimeout;
    
    // Check visibility on scroll
    function checkVisibility() {
      if (checkVisibilityTimeout) clearTimeout(checkVisibilityTimeout);
      
      checkVisibilityTimeout = setTimeout(function() {
        if (isPaymentButtonVisible()) {
          loadPaymentButtons();
          // Remove scroll listener once loaded
          window.removeEventListener('scroll', checkVisibility);
        }
      }, 100);
    }
    
    // Add scroll listener
    window.addEventListener('scroll', checkVisibility, { passive: true });
    
    // Check on initial load
    setTimeout(function() {
      if (isPaymentButtonVisible()) {
        loadPaymentButtons();
      }
    }, 100);
    
    // Load on user interaction
    ['click', 'touchstart'].forEach(event => {
      document.addEventListener(event, function(e) {
        // Load if clicking near the product form
        if (e.target.closest('.product__submit, .product-form, [data-add-to-cart]')) {
          loadPaymentButtons();
        }
      }, { once: true, passive: true });
    });
    
    // Fallback: load after 5 seconds
    setTimeout(loadPaymentButtons, 5000);
  });
})();